import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import BoosterFooter from "../../components/booster-footer/component";
import BoosterHeader from "../../components/booster-header/component";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import queryString from "query-string";

class BoosterLead extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: ""
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/lead');
            ReactGA4.send({ hitType: "pageview", page: "/lead" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    componentDidMount() {
        console.log(this.props);

        let query = queryString.parse(this.props.location.search);
        let messageId = null;

        if(query && query.message){
            messageId = query.message;
        }

        if(this.props.match.params.id){
            dataRegister.getLeadMessages(this.props.match.params.id).then((response) => {
                console.log(JSON.stringify(response));
                this.setState({
                    message: response,
                    messageId: messageId
                })
            }, (error) => {

            });
        }
    }

    _renderText(item) {
        return langRegister.get("booster-lead", item);
    }

    render() {
        return (
              <div className={Styles.view}>
                  {
                      Array.isArray(this.state.message.messages) &&
                      this.state.message.messages.filter((message) => {
                          return message.id === this.state.messageId
                      }).map((message) => {
                          return(
                              <div>
                                  {
                                      message.responses.filter((response) => {
                                          return response.type !== 'BOT_RESPONSE'
                                      }).map((response) => {
                                          return(
                                              <div className={Styles.title}>
                                                  {
                                                      response.type && response.type === 'INPUT_MESSAGE' && !response.value.includes('@') &&
                                                      <div>{this._renderText("item_3") + " "}</div>
                                                  }
                                                  {
                                                      response.value && !response.value.includes('@') &&
                                                      <div className={Styles.subtitle}>{response.value}</div>
                                                  }
                                                  {
                                                      response.type && response.type === 'LC_TICKET' && response.email &&
                                                      <div>{this._renderText("item_4") + " "}</div>
                                                  }
                                                  {
                                                      response.email && response.email &&
                                                      <div className={Styles.subtitle}>{response.email}</div>
                                                  }
                                                  {
                                                      response.type && response.type === 'LC_TICKET' &&
                                                      <div>{this._renderText("item_5") + " "}</div>
                                                  }
                                                  {
                                                      response.subject &&
                                                      <div className={Styles.subtitle}>{response.subject}</div>
                                                  }
                                                  {
                                                      false &&
                                                      response.value &&
                                                      <div>{this._renderText("item_1") + " " + response.value}</div>
                                                  }
                                                  {
                                                      false &&
                                                      Array.isArray(response.responses) &&
                                                      <div>
                                                          {
                                                              response.responses.map((response) => {
                                                                  return(
                                                                      <div>
                                                                          <div className={Styles.subtitle}>
                                                                              {response.message ? this._renderText("item_2") + " " + response.message : ""}
                                                                          </div>
                                                                          {
                                                                              Array.isArray(response.buttons) &&
                                                                              <div className={Styles.tabsSpace}></div>
                                                                          }
                                                                      </div>
                                                                  )
                                                              })
                                                          }
                                                      </div>
                                                  }
                                              </div>
                                          )
                                      })
                                  }
                              </div>
                          )
                      })
                  }
              </div>
        );
    }
}

export default BoosterLead;


// WEBPACK FOOTER //
// ./src/pages/booster-lead/component.js